import script from "./CertificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/certifications/certification-form.css?vue&type=style&index=0&id=55fb8da1&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55fb8da1"]])

export default __exports__